const messages = {
  title: "Listas de preços e brochuras de produtos",
  title_media: "Listas de preços e brochuras de produtos",
  description:
    "Descarregue aqui os folhetos e brochuras mais recentes sobre os pneus Bridgestone e Firestone para automóveis ligeiros, SUV e veículos comerciais.",
  short_description:
    "Aqui pode encontrar materiais para redes sociais, TV em loja e mais.",
  mediaCategories: {
    products: "Produtos",
    brand_and_solutions: "Marca e soluções",
    season_and_promotions: "Época e promoções",
    format: "Formato",
    cars_and_vans: "Ligeiro, SUV, utilitário",
    truck_and_buses: "Pesado e autocarro",
    motorcycle: "Motociclo",
    agriculture: "Agricultura",
    construction_machinery: "Máquinas de construção",
    bridgestone: "Bridgestone",
    firestone: "Firestone",
    bandag: "Bandag",
    bleetcare: "Fleetcare",
    webfleet: "Webfleet",
    material: "Materiais",
    brochures: "Brochuras de produto",
    price_list: "Listas de preços",
    materials: "Materiais",
    video_in_store: "Vídeo com legendas",
    video_online: "Vídeo sem legendas",
    video: "Vídeo",
    banner_website: "Banner",
    banner_social_media: "Redes sociais",
    logos: "Logótipos",
    summer: "Verão",
    winter: "Inverno",
    all_season: "Todas as estações",
    promotions: "Promoções",
    price: "Pricat",
  },
  mediasPage: {
    title: "BIBLIOTECA DE MÍDIA",
    description:
      "Bem-vindo à seção de mídia dedicada   \n" +
      "aos produtos Bridgestone e Firestone.  \n <br> <br>" +
      "Descobrirá imagens de produtos,   \n" +
      "logotipos, bem como uma ampla seleção de   \n" +
      "banners, vídeos e materiais digitais   \n" +
      "para usar no seu site ou nas   \n" +
      "redes sociais.  ",
    bDrive: {
      title: "Fotos de produtos",
      description:
        "As imagens atuais   \n" +
        "podem ser descarregadas   \n" +
        "do nosso portal B-\n" +
        "DRIVE.  ",
    },
  },
  buttons: {
    media: "DESCOBRIR",
  },
  searchMedia: "Introduza uma palavra-chave",
  searchResults: "Resultados da pesquisa",
};

export default {
  messages,
};
